export const CHAT_EVENTS = {
	CHAT_NAMESPACE: 'chat',
	CREATE_CHAT: 'chat:create',
	CREATED_CHAT: 'chat:created',
	EDIT_LAST_CHAT: 'chat:last-edit-prompt',
	EDITED_PROMPT: 'chat:updated-prompt',
	STOP_CHAT: 'chat:stop'
};
